'use strict';

angular.module('gestiondecriseApp').component('crewTeamComponent', {
  templateUrl: 'views/crew/team.html',
  controller: 'CrewTeamCtrl',
});
